import fieldTypes from '../data/fieldTypes.json'

export default function mergeField(field) {
  const overrideSettings = fieldTypes[field.type].overrideSettings
  return {
    ...field,
    ...overrideSettings
  }
}
